import { BackgroundCheckConfig } from '@/backend/features/background-check/defaults';
import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { AppContext } from '@juvare/platform-app/App';
import { SettingColumns, SettingData, settingEntityName } from '@juvare/platform-sdk-react/backend/features/editable-settings/shared';
import { AppState } from '@juvare/platform-sdk-react/types';

export function getBackgroundCheckConfigEnabledType(context: AppContext<AppState>) {
    const settingStorage = context.storage<SettingData, SettingColumns>(settingEntityName);

    const backgroundCheckConfigJSON = settingStorage.list({
        filter: [
            {
                column: 'name',
                op: '=',
                value: 'backgroundCheckConfig',
            },
        ],
    }).rows[0]?.columns?.value;

    const backgroundCheckConfig: BackgroundCheckConfig | undefined = backgroundCheckConfigJSON
        ? JSON.parse(backgroundCheckConfigJSON)
        : undefined;

    const backgroundCheckConfigType = backgroundCheckConfig
        ? (Object.entries(backgroundCheckConfig.type).find(([, value]) => value?.enabled)?.[0] as BackgroundCheckType | undefined)
        : undefined;

    return backgroundCheckConfigType;
}
